/* eslint-disable no-param-reassign */
import { getShouldShowCovid19Banner } from '@utilities/bannersAndModals';
import { createSelector } from '../../utilities';
import { userNotificationSelectors } from '../UserNotifications/ducks';

const { getShouldShowUserNotificationBanner } = userNotificationSelectors;

export const getShouldShowPromotionsBanner = createSelector(
  getShouldShowUserNotificationBanner,
  shouldShowUserNotificationBanner => {
    return !shouldShowUserNotificationBanner;
  }
);


export const getPromotionsWithBanner = state => {
  if (state.header.header.enabledPromotions) {
    return state.header.header.enabledPromotions.filter(promotion => promotion.banner);
  }
  return [];
};

export const getEventableFeatureFlagDetails = state => state.header.header.shouldFireHeaderEventablePageLoadEventStatus;

export const getShouldFireHeaderEventablePageLoadFeatureFlag = state =>
  getEventableFeatureFlagDetails(state)?.shouldFireHeaderEventablePageLoadEvent ?? false;

export const getDoesBannerExist = createSelector(
  getPromotionsWithBanner,
  promotionsWithBanner => promotionsWithBanner.length > 0 || getShouldShowCovid19Banner()
);

export const getPromotionsWithModal = state => {
  if (state.header.header.enabledPromotions) {
    return state.header.header.enabledPromotions.filter(promotion => promotion.modal);
  }
  return [];
};

export const getIsPortrait = state => state.ui.screenSize.isPortrait;

export const selectProfile = state => state.header.profile;

export const selectPartner = state => selectProfile(state).partner;

export const selectIsImpersonating = state => selectProfile(state).isImpersonating;

export const selectUserProfile = state => selectProfile(state).userProfile;

export const getPartnerVanityUrlName = createSelector(selectPartner, partnerDetails => {
  return partnerDetails.partnerVanityUrlName;
});

export const getPartnerWhisperNumber = createSelector(selectPartner, partnerDetails => {
  return partnerDetails.partnerWhisperNumber;
});

export const getIsFinancingExpanded = state => state.header.navigation.isFinancingExpanded;

export const getIsMobileMenuExpanded = state => state.header.navigation.isMobileMenuExpanded;

export const selectModals = state => state.header.modals;
export const getCurrentModalName = state => selectModals(state).currentModal;

export const getIsInDotCom = state => state.header.header.isInDotCom;

export const getDiscounts = state => {
  const { discountsForFavorites: { discounts = [] } } = state.header.discounts;
  return discounts;
};

const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getHeaderBannersAndModals = state => state.header.header.HeaderBannersAndModals;

export const getGeolocation = state => state.header.header.geolocation;

export const selectTrade = state => state.header.header.trade;
